import React, { useMemo, useState } from "react";
import { Title, Description } from "../components/common/title/index";
import { useCart } from "../cart/CartContext";
import "../containers/products/products.scss";
import "../cart/cart.scss";

export default function VariantProductCard({ product }) {
  const { addItem } = useCart();
  const [activeColor, setActiveColor] = useState(product.variants[0].colorKey);
  const [activeSize, setActiveSize] = useState(product.variants[0].sizes?.[0]?.label || null);
  const [quantity, setQuantity] = useState(1);
  const [justAdded, setJustAdded] = useState(false);

  const variant = useMemo(
    () => product.variants.find(v => v.colorKey === activeColor) || product.variants[0],
    [product.variants, activeColor]
  );

  const sizes = variant.sizes || null;

  // priceId is now a real Stripe Price (price_...), resolved from Product
  // IDs via prices-2.csv.
  const selectedSizeEntry = sizes
    ? (activeSize ? sizes.find(s => s.label === activeSize) : null)
    : variant;

  const canAdd = sizes ? Boolean(selectedSizeEntry) : true;

  const handleAddToCart = () => {
    if (!canAdd) return;
    addItem({
      productId: product.id,
      colorKey: variant.colorKey,
      colorLabel: variant.label,
      size: activeSize || null,
      title: product.title,
      image: variant.image,
      price: selectedSizeEntry?.price,
      stripePriceRef: selectedSizeEntry?.priceId || null,
      quantity,
    });
    setJustAdded(true);
    setTimeout(() => setJustAdded(false), 1500);
  };

  return (
    <div className="product-card">
      <div className="prod-image">
        <img src={variant.image} alt={`${product.title} - ${variant.label}`} />
      </div>

      <div className="prod-info">
        <Title Class="prod-title" Name={product.title} />
        <Description Class="prod-dec" Name={product.blurb} />

        {/* Color swatches */}
        <div className="swatches" role="group" aria-label="Choose color">
          {product.variants.map(v => (
            <button
              key={v.colorKey}
              className={`swatch ${activeColor === v.colorKey ? "active" : ""}`}
              style={{ backgroundColor: v.swatch }}
              onClick={() => { setActiveColor(v.colorKey); setActiveSize(v.sizes?.[0]?.label || null); }}
              title={v.label}
              aria-pressed={activeColor === v.colorKey}
            />
          ))}
        </div>

        {/* Sizes */}
        {sizes && (
          <div className="sizes" role="group" aria-label="Choose size">
            {sizes.map(s => (
              <button
                key={s.label}
                className={`size-pill ${activeSize === s.label ? "active" : ""}`}
                onClick={() => setActiveSize(s.label)}
                aria-pressed={activeSize === s.label}
              >
                {s.label}
              </button>
            ))}
          </div>
        )}

        <div className="atc-qty">
          <button type="button" onClick={() => setQuantity(q => Math.max(1, q - 1))} aria-label="Decrease quantity">−</button>
          <span>{quantity}</span>
          <button type="button" onClick={() => setQuantity(q => q + 1)} aria-label="Increase quantity">+</button>
        </div>

        <div className="actions">
          <button
            type="button"
            className={`btn-add-to-cart gradient-color ${canAdd ? "" : "disabled"}`}
            onClick={handleAddToCart}
            disabled={!canAdd}
            title={canAdd ? "Add to cart" : "Select a size to continue"}
          >
            {justAdded ? "Added ✓" : "Add to Cart"}
          </button>
        </div>
      </div>
    </div>
  );
}
